import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AccountInvoiceInformationInput} from "../../../api/psc";

const initialState: AccountInvoiceInformationInput = {
    identificationNumber: '',
    address: '',
    isCompany: false,
    postalCode: '',
    tell: '',
    mobileNumber: '',
    name: '',
}

const storeSlice = createSlice({
    name: 'storeSlice',
    initialState,
    reducers: {
        setStoreState
            : (state: AccountInvoiceInformationInput, action: PayloadAction<AccountInvoiceInformationInput>) => {
            return action.payload;
        },
        changeIdentificationNumber: (state, action: PayloadAction<string>) => {
            state.identificationNumber = action.payload;
        },
        changeAddress: (state, action: PayloadAction<string>) => {
            state.address = action.payload;
        },
        changePostalCode: (state, action: PayloadAction<string>) => {
            state.postalCode = action.payload;
        },
        changeTell: (state, action: PayloadAction<string>) => {
            state.tell = action.payload;
        },
        changeMobileNumber: (state, action: PayloadAction<string>) => {
            state.mobileNumber = action.payload;
        },
        changeIsCompany: (state, action: PayloadAction<boolean>) => {
            state.isCompany = action.payload;
        },
        changeName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        clearState: (state: AccountInvoiceInformationInput) => {
            return initialState;
        }
    }
})

export const {
    changeIdentificationNumber,
    changeIsCompany,
    changeMobileNumber,
    changeAddress,
    changeTell,
    changePostalCode,
    clearState,
    changeName,
    setStoreState,
} = storeSlice.actions;
export default storeSlice.reducer;
